// extracted by mini-css-extract-plugin
export var colorSquare = "_r3-0";
export var danger = "_r3-5";
export var lightPink = "_r3-8";
export var neutralBlue = "_r3-7";
export var neutralYellow = "_r3-6";
export var normal = "_r3-1";
export var primary = "_r3-2";
export var primaryLight = "_r3-3";
export var solidBlack = "_r3-g";
export var solidGreen = "_r3-b";
export var solidLightBlue = "_r3-d";
export var solidNavy = "_r3-c";
export var solidOrange = "_r3-f";
export var solidPink = "_r3-e";
export var solidRed = "_r3-9";
export var solidYellow = "_r3-a";
export var success = "_r3-4";